(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-v-office-call-us-now"] && !Shopify.designMode) return;
  try {
    
document.querySelector(".voffice-call-icon").addEventListener("click", function (event) {
  event.preventDefault();

  var existingWidget = document.querySelector("voffice-widget");

  if (!existingWidget) {
   var script = document.createElement("script");
   script.src = "https://voffice_world_llc.voffice.pro/widget/voffice-widget.js";
   document.head.appendChild(script);

   var vofficeWidget = document.createElement("voffice-widget");
   vofficeWidget.setAttribute("namespace", "https://voffice_world_llc.voffice.pro");
   vofficeWidget.setAttribute("title", "Click here to contact us via video call");
   vofficeWidget.setAttribute("color", "#E30D18");
   vofficeWidget.setAttribute(
    "position",
    JSON.stringify({
     position: "right",
     bottomPx: 0,
     rightPx: 0,
     leftPx: 0
    })
   );

   document.querySelector("body").appendChild(vofficeWidget);

   var checkExist = setInterval(function () {
    var vofficeIcon = document.querySelector(".fab-cantainer");
    if (vofficeIcon) {
     clearInterval(checkExist);
     vofficeIcon.click();
    }
   }, 500);
  } else {
   var checkExist = setInterval(function () {
    var vofficeIcon = document.querySelector(".fab-cantainer");
    if (vofficeIcon) {
     clearInterval(checkExist);
     vofficeIcon.click();
    }
   }, 500);
  }
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-voffice-button"] && !Shopify.designMode) return;
  try {
    
document.getElementById("button-beacon").addEventListener("click", function (event) {
  event.preventDefault();

  var existingWidget = document.querySelector("voffice-widget");

  function openWidget() {
    var attempts = 0;

    var checkExist = setInterval(function () {
      var vofficeIcon = document.querySelector(".fab-cantainer");

      if (vofficeIcon) {
        clearInterval(checkExist);
        vofficeIcon.click();
      }

      attempts++;

      if (attempts >= 20) {
        clearInterval(checkExist);
      }
    }, 500);
  }

  if (existingWidget) {
    openWidget();
    return;
  }

  var currentLang = (
    document.documentElement.lang ||
    document.documentElement.getAttribute("lang") ||
    "en"
  ).toLowerCase().split("-")[0];

  var isGerman = currentLang === "de";

  var widgetNamespace = isGerman
    ? "https://ra-micro2.voffice.pro"
    : "https://voffice_world_llc.voffice.pro";

  var widgetScript = isGerman
    ? "https://ra-micro2.voffice.pro/widget/voffice-widget.js"
    : "https://voffice_world_llc.voffice.pro/widget/voffice-widget.js";

  var widgetIcon = isGerman
    ? "https://ra-micro2.voffice.pro/userMedia/avatars/ra-micro2.voffice.pro/ra-micro2.voffice.pro.png?_=1691043430481"
    : null;

  var script = document.createElement("script");
  script.src = widgetScript;
  script.async = true;

  script.onload = function () {
    var vofficeWidget = document.createElement("voffice-widget");

    vofficeWidget.setAttribute("namespace", widgetNamespace);
    vofficeWidget.setAttribute(
      "title",
      isGerman
        ? "Klicken Sie hier, um uns per Videoanruf zu kontaktieren"
        : "Click here to contact us via video call"
    );
    vofficeWidget.setAttribute("color", "#E30D18");
    vofficeWidget.setAttribute("iconsize", "small");
    vofficeWidget.setAttribute("language", isGerman ? "de" : currentLang);

    vofficeWidget.setAttribute(
      "position",
      JSON.stringify({
        position: "right",
        bottomPx: 0,
        rightPx: 0,
        leftPx: 0
      })
    );

    if (widgetIcon) {
      vofficeWidget.setAttribute("icon", widgetIcon);
    }

    document.body.appendChild(vofficeWidget);
    openWidget();
  };

  script.onerror = function () {
    console.error("The vOffice widget script could not be loaded:", widgetScript);
  };

  document.head.appendChild(script);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-voffice-gsap-horizont-scroll"] && !Shopify.designMode) return;
  try {
    

    let sections = gsap.utils.toArray("#hori-panel");
    gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: "none",
        scrollTrigger: {
            trigger: "#hori-container",
            pin: true,
            scrub: 1,
            snap: 1 / (sections.length - 1),
            end: "+=7500",
            markers: true
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-voffice-gsap-rechts-links-oben"] && !Shopify.designMode) return;
  try {
    
    gsap.registerPlugin(ScrollTrigger);
    const tlbild = gsap.timeline();
    //tlbild.from(".bild-1", { xPercent: -100 })
    tlbild.from(".bild-2", { xPercent: 100 })
        .from(".bild-3", { yPercent: 100 })
        .from(".bild-4", { xPercent: -100 });

   /* ScrollTrigger.create({
        animation: tlbild,
        trigger: "#cont",
        start: "top top",
        end: "+=4000",
        scrub: true,
        pin: true,
        anticipatePin: 1
    });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-voffice-gsap-split"] && !Shopify.designMode) return;
  try {
    
    const details = gsap.utils.toArray(".desktopContentSection:not(:first-child)")
    const photos = gsap.utils.toArray(".desktopPhoto:not(:first-child)")
    gsap.set(photos, { yPercent: 101 })
    /*ScrollTrigger.create({
        trigger: ".gallery",
        start: "top top",
        end: "bottom bottom",
        pin: ".right"
    });

    details.forEach((detail, index) => {
        let headline = detail.querySelector("h1")
        ScrollTrigger.create({
            trigger: headline,
            start: "top 80%",
            end: "top 50%",
            animation: gsap.to(photos[index], { yPercent: 0 }),
            scrub: true,
            markers: false
        })
    });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-voffice-gsap-video-max"] && !Shopify.designMode) return;
  try {
    
const video = document.querySelector(".header-video");
const playButton = document.querySelector("#play-toggle");
const audioButton = document.querySelector("#audio-toggle");
playButton.addEventListener("click", () => {
    if (video.paused) {
        video.play();
        playButton.classList.add("fa-circle-pause");
        playButton.classList.remove("fa-circle-play");
    } else {
        video.pause();
        playButton.classList.add("fa-circle-play");
        playButton.classList.remove("fa-circle-pause");
    }
});
audioButton.addEventListener("click", () => {
    if (video.muted) {
        video.muted = false;
        audioButton.classList.add("fa-volume-up");
        audioButton.classList.remove("fa-volume-mute");
    } else {
        video.muted = true;
        audioButton.classList.add("fa-volume-mute");
        audioButton.classList.remove("fa-volume-up");
    }
});
document.addEventListener("scroll", () => {
    // Wenn die Seite nicht ganz nach oben gescrollt ist, pausiere das Video
    if (window.scrollY > 0) {
        video.pause();
        playButton.classList.add("fa-circle-play");
        playButton.classList.remove("fa-circle-pause");
    }
    else {
        video.play();
        playButton.classList.add("fa-circle-pause");
        playButton.classList.remove("fa-circle-play");
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
